import { Input } from 'antd';
import React from 'react';
import { cond } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';

const InputTeamName = ({
  teamName,
  className,
  touched,
  isFocus,
  setTeamName,
  alreadyExists,
  isValid,
  onBlur,
  onFocus
}) => {
  const displayError = touched && !isFocus;
  const error = cond([
    [() => displayError && !isValid, () => 'Le nom d\'équipe doit contenir 2 caractères minimum.'],
    [() => displayError && alreadyExists, () => 'Une équipe avec ce nom existe déjà.'],
    [() => true, () => null]
  ])();

  return (
    <div className="flex flex-col">
      <Input
        className={className}
        placeholder="Nom d'équipe"
        value={teamName}
        onChange={e => setTeamName(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        width={300}
        maxLength={100}
      />
      {isNotNilOrEmpty(error) && (
        <p className="text-flexi-error mt-2 whitespace-nowrap">{error}</p>
      )}
    </div>
  );
};

export default InputTeamName;